export const truncate = (value: string = '', truncateTo: number = 10) =>
  value.length > truncateTo ? `${value.slice(0, truncateTo)}...` : value;
